import { useMutation } from '@tanstack/react-query';

import postHostUserImage from 'Api/productivity-host/postHostUserImage';
import postHostUserImageRequest from './model/request/postHostUserImageRequest';
import postHostUserImageResponse from './model/response/postHostUserImageResponse';

import { useToast } from 'Store/toast';
import useIsMobile from 'Hook/useIsMobile';
import getApiErrorMessage from 'Helper/getApiErrorMessage';

const usePostHostUserImage = () => {
  const { onOpenToast } = useToast();
  const isMobile = useIsMobile();

  return useMutation({
    mutationFn: async (data) => {
      const payload = await postHostUserImageRequest(data);

      const response = await postHostUserImage(payload);

      const result = postHostUserImageResponse(response);

      return result;
    },
    onSuccess: async () => {
      onOpenToast({
        description: 'User image uploaded successfully',
        status: 'success',
        duration: 5,
        position: 'top',
        type: isMobile ? 'mobile' : 'desktop',
      });
    },
    onError: async (error) => {
      onOpenToast({
        description: getApiErrorMessage(error?.response?.data?.message),
        status: 'failed',
        duration: 5,
        position: 'top',
        type: isMobile ? 'mobile' : 'desktop',
      });
    },
  });
};

export default usePostHostUserImage;
